export const fbCaCase = {
    fbFalseCaTrue: 1,
    fbTrueCaFalse: 2,
    fbTrueCaTrue: 3,
    fbOptionalCaTrue: 4,
    fbOptionalCaOptional: 5,

}